export function reorderPricingVehicles(
  vehicles,
  serviceBooking,
  sourceIndex,
  targetIndex,
) {
  const selectedVehicles = vehicles.filter(
    (vehicle) => Number(vehicle.serviceBooking) === Number(serviceBooking),
  );

  if (
    !Number.isInteger(sourceIndex) ||
    !Number.isInteger(targetIndex) ||
    sourceIndex < 0 ||
    targetIndex < 0 ||
    sourceIndex >= selectedVehicles.length ||
    targetIndex >= selectedVehicles.length ||
    sourceIndex === targetIndex
  ) {
    return vehicles;
  }

  const [movedVehicle] = selectedVehicles.splice(sourceIndex, 1);
  selectedVehicles.splice(targetIndex, 0, movedVehicle);
  const orderedVehicles = selectedVehicles.map((vehicle, index) => ({
    ...vehicle,
    order: index + 1,
  }));

  let selectedIndex = 0;
  return vehicles.map((vehicle) =>
    Number(vehicle.serviceBooking) === Number(serviceBooking)
      ? orderedVehicles[selectedIndex++]
      : vehicle,
  );
}
